<template>
  <div>
    <header
      class="text-primary black l-s-0.175 m-b-80"
    >
      <h2
        class="f-s-54 l-h-65 m-b-7"
      >
        {{ service.routeName }}
      </h2>
      <h4
        class="f-w-600 f-s-24 l-h-29"
      >
        {{ service.subtitle }}
      </h4>
    </header>
    <Paragraph
      :paragraph="service.desc.p1"
      p-item-distance
    />
    <img
      :src="service.imgSrc"
      alt="Fluid image"
      class="m-t-87 m-b-87"
    >
    <Paragraph
      :paragraph="service.desc.p2"
      p-distance
    />
    <Paragraph
      :paragraph="service.desc.p3"
    />
    <ul class="ml-3">
      <li
        v-for="(item, i) in listItems"
        :key="i"
        class="article-text mb-0 l-s-0_08 grey-dark"
      >
        {{ item }}
      </li>
    </ul>

    <ServiceProps
      :items="service.desc.props"
    />
    <Paragraph
      :paragraph="service.desc.p4"
      p-item-distance
    />
  </div>
</template>

<script>
import Paragraph from '@/components/Paragraph';
import ServiceProps from '@/components/Services/ServiceProps';

export default {
  name: 'StatisticalProgramming',
  components: {
    ServiceProps,
    Paragraph,
  },
  props: {
    service: {
      type: Object,
      default: null,
    },
    serviceDesc: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      listItems: [
        'SAS and R programming',
        'Macro production, validation, and optimization',
        'Interim analysis support',
        'Annual clinical trial safety updates',
        'CDISC mapping/conversion possibilities',
        'CDISC ADaM submission-ready dataset development and QC for submission compliance',
        'Support and mapping of safety data for Data Monitoring Committee (DMC), Data Safety '
        + 'Monitoring Boards (DSMB), Safety Committee and Endpoint Committee',
        'Analysis Datasets and TLFs Development, and QC for standard studies and '
        + 'Integrated Summaries',
      ],
    };
  },
};
</script>
